const intro = {
  eyebrow: '02 — Before you begin',
  titleLead: 'Just before',
  titleAccent: 'you start.',
  subDesktop:
    'You will be asked about how you work and what energises you. Always choose what fits you best — not what sounds good.',
  subMobile:
    'You will be asked about how you work. Always choose what fits you best.',

  cards: [
    {
      title: 'How do you choose?',
      text: "Pick whatever sounds most like you. Not sure? Go with what feels strongest — not what sounds 'right'.",
    },
    {
      title: 'Several options fit?',
      text: 'That is normal. You are not a box to tick. The result deliberately shows your mix of personas too.',
    },
    {
      title: 'How long does it take?',
      text: 'Nine questions, about five minutes. Nothing to prepare. Just answer honestly.',
    },
  ],

  actionStrong: 'Important:',
  actionText:
    'this is not a right-or-wrong test. It is about what comes most naturally to you.',
  btnStart: 'Start the questions',
  btnBack: 'Back',
};

export default intro;
